import { combineReducers } from "redux";
// import axios from "axios";
import { API } from "../../const";
import _ from 'lodash';
import { unAuthorized } from '../../modules/auth/Auth.ducks'
import { Service } from "../../modules/service/service"

// Arrivée actions

export const FETCH_AGENT_PENDING = "FETCH_AGENT_PENDING";
export const FETCH_AGENT_REJECTED = "FETCH_AGENT_REJECTED";
export const FETCH_AGENT_FULFILLED = "FETCH_AGENT_FULFILLED";

export const GET_ABON_PENDING = "GET_ABON_PENDING";
export const GET_ABON_REJECTED = "GET_ABON_REJECTED";
export const GET_ABON_FULFILLED = "GET_ABON_FULFILLED";

export const UPDATE_AGENT_PENDING = "UPDATE_AGENT_PENDING";
export const UPDATE_AGENT_REJECTED = "UPDATE_AGENT_REJECTED";
export const UPDATE_AGENT_FULFILLED = "UPDATE_AGENT_FULFILLED";

export const UPDATE_PASSWORD_PENDING = "UPDATE_PASSWORD_PENDING";
export const UPDATE_PASSWORD_REJECTED = "UPDATE_PASSWORD_REJECTED";
export const UPDATE_PASSWORD_FULFILLED = "UPDATE_PASSWORD_FULFILLED";

export const UPDATE_PHOTO_COMPTE_PENDING = "UPDATE_PHOTO_COMPTE_PENDING";
export const UPDATE_PHOTO_COMPTE_REJECTED = "UPDATE_PHOTO_COMPTE_REJECTED";
export const UPDATE_PHOTO_COMPTE_FULFILLED = "UPDATE_PHOTO_COMPTE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case FETCH_AGENT_PENDING:
    case UPDATE_PHOTO_COMPTE_PENDING:
      return true;
    case FETCH_AGENT_REJECTED:
    case FETCH_AGENT_FULFILLED:
    case UPDATE_PHOTO_COMPTE_REJECTED:
    case UPDATE_PHOTO_COMPTE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_AGENT_FULFILLED:
    case FETCH_AGENT_PENDING:
    case UPDATE_PHOTO_COMPTE_FULFILLED:
    case UPDATE_PHOTO_COMPTE_PENDING:
      return null;
    case FETCH_AGENT_REJECTED:
    case UPDATE_PHOTO_COMPTE_REJECTED:
      return payload;
    default:
      return null;
  }
};
const pwdError = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_PASSWORD_FULFILLED:
    case UPDATE_PASSWORD_PENDING:
      return null;
    case UPDATE_PASSWORD_REJECTED:
      return _.isEmpty(payload.response.data) ? null : payload.response.data.message;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_AGENT_FULFILLED:
    case UPDATE_PHOTO_COMPTE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return state;
  }
};
const abonnement = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ABON_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return state;
  }
};
export default combineReducers({ loading, error, data, pwdError, abonnement });

export const fetchAgent = (tok, id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_AGENT_PENDING })
    const response = Service.get(`${API}api/creche/agents/${id}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
       dispatch({ type: FETCH_AGENT_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: FETCH_AGENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updateAgent = (tok, id, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_AGENT_PENDING })
    const response = Service.put(`${API}api/creche/agents/${id}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_AGENT_FULFILLED, payload: res })
      dispatch(fetchAgent(tok, id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_AGENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updatePassword = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PASSWORD_PENDING })
    const response = Service.post(`${API}api/auth/compte/passwords/change`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_PASSWORD_FULFILLED, payload: res })
      dispatch(unAuthorized())
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_PASSWORD_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const getAbonnement = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_ABON_PENDING })
    const response = Service.get(`${API}api/creche/abonnements`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ABON_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ABON_REJECTED, payload: err })
      if (err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updatePhotoAgent = (tok, id, idPhoto) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/creche/agents/${id}/photo`, {idPhoto: idPhoto}, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_PHOTO_COMPTE_FULFILLED, payload: res })
      dispatch(fetchAgent(tok, id))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_PHOTO_COMPTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}



